import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { checkAutoLogin } from '../../services/AuthService';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const PrivateRoute = ({ children, isAuthenticated }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        checkAutoLogin(dispatch, navigate);
    }, [dispatch, navigate]);

    console.log('PrivateRoute isAuthenticated:', isAuthenticated); // Debug log

    return isAuthenticated ? children : <Navigate to="/login" />;
};

const mapStateToProps = (state) => {
    console.log('PrivateRoute state:', state); // Debug log
    return {
        isAuthenticated: state.auth.isAuthenticated,
    };
};

export default connect(mapStateToProps)(PrivateRoute); 